import { render, staticRenderFns } from "./screens-limit.vue?vue&type=template&id=6e98ed83&scoped=true"
import script from "./screens-limit.vue?vue&type=script&lang=js"
export * from "./screens-limit.vue?vue&type=script&lang=js"
import style0 from "./screens-limit.vue?vue&type=style&index=0&id=6e98ed83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e98ed83",
  null
  
)

export default component.exports